import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase'; // il file di configurazione Firebase
import { useNavigate  } from 'react-router-dom';
import '../../styles/Login.scss';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const history = useNavigate ();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      history.push('/admin'); // Reindirizza alla pagina di admin
    } catch (error) {
      setError('Errore nel login: ' + error.message);
    }
  };

  return (
    <div className="login-form">
      <h2>Pannello amministratore</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error && <p>{error}</p>}
        <button type="submit">Accedi</button>
      </form>
    </div>
  );
};

export default Login;
